import { Translatable } from '@icc/shared/helpers';

export class CableExitType {
    id: number;
    @Translatable({ model: 'CableExitTypes' })
    name: string;
    nameCms: string;
    code: CableExitCode;
    img: string | null;
    extId: string | null;
    order: number;
    active: boolean;
    shutterTypesIds: number[];
}


export type CableExitCode = 'A' | 'B' | 'C' | null;
